import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout as DashboardLayout } from 'src/layouts/setting';
import Loader from 'src/pages/components/loader';

// const IndexPage = lazy(() => import('src/pages/inv/index'));


// inventory
const MenuCatListPage = lazy(() => import('src/pages/inv/itemCategory/itemCategoryList'));
const MenuCatCreatePage = lazy(() => import('src/pages/inv/itemCategory/createItemCategory'));
const UnitListPage = lazy(() => import('src/pages/inv/unit/unitList'));
const UnitCreatePage = lazy(() => import('src/pages/inv/unit/createUnit'));
const AttributesListPage = lazy(() => import('src/pages/inv/attributes/attributesList'));
const AttributesCreatePage = lazy(() => import('src/pages/inv/attributes/createAttributes'));
const FloorListPage = lazy(() => import('src/pages/inv/floor/floorList'));
const FloorCreatePage = lazy(() => import('src/pages/inv/floor/createFloor'));
const ItemListPage = lazy(() => import('src/pages/inv/item/itemList'));
const ItemCreatePage = lazy(() => import('src/pages/inv/item/createItem'));
const PromotionListPage = lazy(() => import('src/pages/inv/promotionReward/promotionRewardList'));
const PromotionCreatePage = lazy(() => import('src/pages/inv/promotionReward/createPromotionReward'));
const LoyaltyPointRewardListPage = lazy(() => import('src/pages/inv/loyaltyPointReward/loyaltyPointRewardList'));
const LoyaltyPointRewardCreatePage = lazy(() => import('src/pages/inv/loyaltyPointReward/createLoyaltyPointReward'));

// Customer
const CustCatListPage = lazy(() => import('src/pages/customer/customerCategory/customerCategoryList'));
const CustCatCreatePage = lazy(() => import('src/pages/customer/customerCategory/createCustomerCategory'));
const CustListPage = lazy(() => import('src/pages/customer/customer/customerList'));
const CustCreatePage = lazy(() => import('src/pages/customer/customer/createCustomer'));
const CustGiftCardListPage = lazy(() => import('src/pages/customer/custGiftCard/custGiftCardList'));
const CustCreateGiftCardPage = lazy(() => import('src/pages/customer/custGiftCard/createCustGiftCard'));
const TransactionListPage = lazy(() => import('src/pages/Transaction/transactionList'));
const TransactionCreatePage = lazy(() => import('src/pages/Transaction/createTransaction'));
const AccountsPage = lazy(() => import('src/pages/Transaction/accountsList'));
const CreateAccountPage = lazy(() => import('src/pages/Transaction/createAccount'));

// salesReport
const SalesByDatePage = lazy(() => import('src/pages/salesReports/salesByDay'));
const SalesByMenuPage = lazy(() => import('src/pages/salesReports/salesByMenu'));
const SalesByPaymentTypePage = lazy(() => import('src/pages/salesReports/salesByPaymentType'));
const SalesByCategoryPage = lazy(() => import('src/pages/salesReports/salesByCategory'));
const SalesByInvoicePage = lazy(() => import('src/pages/salesReports/salesByInvoice'));
const SalesByCustomerPage = lazy(() => import('src/pages/salesReports/salesByCustomer'));
const SalesByCashierPage = lazy(() => import('src/pages/salesReports/salesByCashier'));
const SalesByDineInPage = lazy(() => import('src/pages/salesReports/salesByDineIn'));
const CashierInOutPage = lazy(() => import('src/pages/salesReports/cashierInOutReports'));
const InvoiceDetailsPage = lazy(() => import('src/pages/salesReports/InvoiceDetails'));

// products (client storefront)
const ProductListPage = lazy(() => import('src/pages/inv/products/productList'));
const ProductCreatePage = lazy(() => import('src/pages/inv/products/createProduct'));
const MyCartsPage = lazy(() => import('src/pages/inv/products/myCarts'));
const OrderSummeryPage = lazy(() => import('src/pages/inv/products/orderSummery'));
const PaymentResponsePage = lazy(() => import('src/pages/inv/products/PaymentResponse'));

export const invRoutes = [
  {
    path: 'inv',
    element: (
      <Suspense fallback={<Loader message="Loading..." loaderSize={60} />}>
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    </Suspense>
    ),
    children: [
      // {
      //   index: true,
      //   element: <IndexPage />
      // },
      {
        path: 'itemCategory',
        children: [
          {
            index: true,
            element: <MenuCatListPage />
          },
          {
            path: 'createItemCategory',
            element: <MenuCatCreatePage />
          },
        ]
      },
      {
        path: 'unit',
        children: [
          {
            index: true,
            element: <UnitListPage />
          },
          {
            path: 'createUnit',
            element: <UnitCreatePage />
          }
        ]
      },
      {
        path: 'attributes',
        children: [
          {
            index: true,
            element: <AttributesListPage />
          },
          {
            path: 'createAttributes',
            element: <AttributesCreatePage />
          }
        ]
      },
      {
        path: 'floor',
        children: [
          {
            index: true,
            element: <FloorListPage />
          },
          {
            path: 'createFloor',
            element: <FloorCreatePage />
          }
        ]
      },
      {
        path: 'item',
        children: [
          {
            index: true,
            element: <ItemListPage />
          },
          {
            path: 'createItem',
            element: <ItemCreatePage />
          }
        ]
      },
      {
        path: 'promotionReward',
        children: [
          {
            index: true,
            element: <PromotionListPage />
          },
          {
            path: 'createPromotionReward',
            element: <PromotionCreatePage />
          }
        ]
      },
      {
        path: 'loyaltyPointReward',
        children: [
          {
            index: true,
            element: <LoyaltyPointRewardListPage />
          },
          {
            path: 'createLoyaltyPointReward',
            element: <LoyaltyPointRewardCreatePage />
          }
        ]
      },
      {
        path: 'customerCategory',
        children: [
          {
            index: true,
            element: <CustCatListPage />
          },
          {
            path: 'createCustomerCategory',
            element: <CustCatCreatePage />
          }
        ]
      },
      {
        path: 'customer',
        children: [
          {
            index: true,
            element: <CustListPage />
          },
          {
            path: 'createCustomer',
            element: <CustCreatePage />
          }
        ]
      },
      {
        path: 'transaction',
        children: [
          {
            index: true,
            element: <AccountsPage />
          },
          {
            path: 'createAccount',
            element: <CreateAccountPage />
          },
          {
            path: 'transactionList',
            element: <TransactionListPage />
          },
          {
            path: 'createTransaction',
            element: <TransactionCreatePage />
          }
        ]
      },
      {
        path: 'custGiftCard',
        children: [
          {
            index: true,
            element: <CustGiftCardListPage />
          },
          {
            path: 'createCustGiftCard',
            element: <CustCreateGiftCardPage />
          }
        ]
      },

      //reports
      {
        path: 'salesReports',
        children: [
          {
            index: true,
            element: <SalesByDatePage />
          },
          {
            path: 'salesByMenu',
            element: <SalesByMenuPage />
          },
          {
            path: 'salesByPaymentType',
            element: <SalesByPaymentTypePage />
          },
          {
            path: 'salesByCategory',
            element: <SalesByCategoryPage />
          },
          {
            path: 'salesByInvoice',
            element: <SalesByInvoicePage />
          },
          {
            path: 'salesByCustomer',
            element: <SalesByCustomerPage />
          },
          {
            path: 'salesByCashier',
            element: <SalesByCashierPage />
          },
          {
            path: 'cashierInOutReports',
            element: <CashierInOutPage />
          },
          {
            path: 'salesByDineIn',
            element: <SalesByDineInPage />
          },
          {
            path: 'invoiceDetails',
            element: <InvoiceDetailsPage />
          },
        ]
      },
      {
        path: 'product',
        children: [
          {
            index: true,
            element: <ProductListPage />
          },
          {
            path: 'createProduct',
            element: <ProductCreatePage />
          },
          {
            path: 'myCarts',
            element: <MyCartsPage />
          },
          {
            path: 'orderSummery',
            element: <OrderSummeryPage />
          },
          {
            path: 'payment-response',
            element: <PaymentResponsePage />
          },
        ]
      },

    ]
  }
];
